export default "__VITE_ASSET__DgzmBImp__"